import PropTypes from 'prop-types';

import styles from './MobileDocumentBody.module.scss';

/**
 * 모바일 문서 본문 컴포넌트
 * - 문서 본문을 이미지로 표시 (모바일 전용)
 * - PC 버전의 CKEditor 대신 사용
 */
function MobileDocumentBody({ imageUrl, isLoading, title }) {
  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingPlaceholder}>
          <div className={styles.spinner} />
          <span>이미지 로딩 중...</span>
        </div>
      </div>
    );
  }

  if (!imageUrl) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyMessage}>문서 본문 이미지를 불러올 수 없습니다.</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img
          src={imageUrl}
          alt={title || '문서 본문'}
          className={styles.contentImage}
          loading="lazy"
        />
      </div>
    </div>
  );
}

MobileDocumentBody.propTypes = {
  imageUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
};

MobileDocumentBody.defaultProps = {
  imageUrl: null,
  isLoading: false,
  title: '문서 본문',
};

export default MobileDocumentBody;
